<template>
  <div class="chat">
    <div v-if="user">
      <audio ref="chatNotifi">
        <source src="/static_files/chat_notifi.mp3" type="audio/mpeg">
        Your browser does not support the audio element.
      </audio>
      <!-- <audio ref="calling" loop>
        <source src="/static_files/outgoing_call.mp3" type="audio/mpeg">
        Your browser does not support the audio element.
      </audio>
      <audio ref="incoming" loop>
        <source src="/static_files/incoming_call.mp3" type="audio/mpeg">
        Your browser does not support the audio element.
      </audio> -->
    </div>

    <transition v-if="!showChat" name="toTop">
      <span class="users-online">
        <!-- <button v-if="messagesPush" @click="messagesPush = null" class="mp-clean">Закрыть</button> -->
        <!-- <transition-group v-if="messagesPush.length" class="messages-push" name="toTop" tag="div">
          <nuxt-link v-for="mp in messagesPush" :key="`mp-item-${mp.message.date}`" :to="`/cinema/${mp.room}`" class="message-push">
            <div class="avatar">
              <img :src="mp.message.user.photo" alt="">
            </div>
            <div>
              <strong>
                {{ mp.message.user.name.length > 23 ? `${mp.message.user.name.slice(0, 20)}...` : mp.message.user.name }}
              </strong>
              <p>{{ mp.message.text.length > 33 ? `${mp.message.text.slice(0, 30)}...` : mp.message.text }}</p>
            </div>
          </nuxt-link>
        </transition-group> -->

        <transition-group name="fade" tag="div" class="list">
          <div
            v-for="(item, i) in members.users.slice(0, 5)"
            :key="`user-online-${item.user.id}`"
            @click="showChatToggle"
            :style="`transform: translateX(-${i * 20}px)`"
            class="user"
          >
            <div class="avatar">
              <img :src="item.user.photo" alt="">
            </div>
            <span>
              {{ item.user.name.length > 10 ? `${item.user.name.slice(0, 7)}...` : item.user.name }}
            </span>
          </div>
        </transition-group>
        <span v-if="members.users.length" @click="showChatToggle" class="total">
          <span v-if="!showChatRead">{{ isDesktop ? 'Количество участников онлайн' : 'Участники онлайн' }}: <strong>{{ members.count }}</strong></span>
          <span v-else>Нажмите, чтобы прочитать</span>

          <sup v-if="messagesUnread" title="Непрочитанные сообщения">
            {{ messagesUnread }}
          </sup>
        </span>
      </span>
      <!-- <button @click="showChatToggle" class="activated-chat">
        <i class="bell" />
        <sup v-if="messagesUnread" title="Непрочитанные сообщения">
          {{ messagesUnread }}
        </sup>
      </button> -->
    </transition>
    <transition v-else name="toTop">
      <div :class="{ global: globalChat, resize: resizeChat }">
        <div v-if="globalChat || isChat" class="chat-header">
          <!-- <strong>Чат <sup title="Непрочитанные сообщения">{{ messagesUnread }}</sup></strong>
          <span class="chat-toggle">
            {{ showChat ? 'Скрыть' : 'Показать' }}
          </span> -->
          <div class="actions">
            <div>
              <span v-if="globalChat" @click="showChatToggle">
                <i class="arrow-right" /> Закрыть
              </span>
            </div>
            <div>
              <span>
                <i v-if="isDesktop && globalChat" @click="resizeChat = !resizeChat" :class="{ active: resizeChat }" class="resize" title="Во весь экран" />
              </span>
              <span @click="mute = !mute">
                <i :class="{ active: mute }" class="mute" title="Выключить уведомления" />
                {{ isChat ? 'Звуковые уведомления' : '' }}
              </span>
              <!-- <i @click="showCreateRoom = true" class="create" title="Создать комнату" /> -->
              <span v-if="user && user.id === room.owner" @click="deleteRoom(room.id)">
                <i class="delete" title='Удалить комнату' />
                {{ isChat ? 'Удалить комнату' : '' }}
              </span>
              <span @click="getRooms">
                <i class="list" title="Список комнат" />
                {{ isChat ? 'Список комнат' : 'Комнаты' }}
              </span>
            </div>
          </div>
        </div>
        <transition name="toLeft">
          <div v-if="showRoomsList" class="rooms-list">
            <h4>Список чат-комнат:</h4>
            <ul>
              <li @click="goToRoom({ _id: 'global', owner: null, title: 'Общая' })" class="room">
                <div class="poster">
                  <img src="https://wallegend.net/gif/1521.gif" alt="">
                </div>
                <strong :style="{ color: 'global' === room.id ? '#8bc34a' : '', 'font-weight': 'global' === room.id ? 'bold' : '' }">
                  Общая
                </strong>
                <!-- <span>Участники онлайн: {{ roomsList['global'].online ? roomsList['global'].online : '0' }}</span> -->
              </li>
              <li v-for="r in roomsList" :key="`chat-room-${r._id}`" @click="goToRoom(r)" class="room">
                <div class="poster">
                  <img :src="r.poster" alt="">
                </div>
                <strong :style="{ color: r._id === room.id ? '#8bc34a' : '', 'font-weight': r._id === room.id ? 'bold' : '' }">
                  {{ r.title }}
                </strong>
                <span>Участники онлайн: {{ r.online ? r.online : '0' }}</span>
                <!-- <time v-if="r.date">{{ r.date | filterDate }}</time> -->
                <div class="avatar">
                  <img v-if="user" :src="user.photo" :title="user.name" alt="">
                </div>
              </li>
            </ul>

            <div @click="showRoomsList = false" class="actions">
              <button @click="showCreateRoom = true" class="dbtn green">
                Создать свою
              </button>
              &middot;
              <span>Закрыть <i class="arrow" /></span>
              <nuxt-link to="/cinema">Комнаты совместного просмотра</nuxt-link>
            </div>
          </div>
        </transition>
        <transition name="toLeft">
          <div v-if="showCreateRoom" class="create-room">
            <div v-if="roomCreated">
              <p>Название комнаты: <strong>{{ roomCreated.title }}</strong></p>
              <p>{{ roomCreated.hidden ? 'Скрытая' : 'Открытая комната' }}</p>
              <button @click="goToRoom(roomCreated)">Перейти в комнату</button>
              <span @click="deleteRoom(roomCreated._id)">Удалить</span>
            </div>
            <div v-else>
              <label for="create-room-input">
                Название комнаты
                <input id="create-room-input" v-model="createRoomTitle" type="text" min="3" max="60">
              </label>
              <button @click="uploadTrigger" class="bg">
                Загрузить постер
              </button>
              <input
                ref="upload"
                type="file"
                style="display:none;"
                accept="image/gif, image/png, image/jpeg, image/jpg"
                @change="uploadFile($event, 'room')"
              >
              <label for="create-room-checkbox">
                <input id="create-room-checkbox" v-model="createRoomHidden" type="checkbox">
                Скрыть комнату
              </label>
              <div class="prerender">
                <h5>Как будет выглядеть комната в списке</h5>
                <div class="room">
                  <div class="poster" />
                  <strong>{{ createRoomTitle }}</strong>
                  <span class="members">Участники онлайн: 56</span>
                  <div class="avatar">
                    <img v-if="user" :src="user.photo" :title="user.name" alt="">
                  </div>
                </div>
                <button @click="createRoom">Создать</button>
                <span @click="showCreateRoom = false">Отмена</span>
              </div>
            </div>
          </div>
        </transition>
        <div class="chat-area">
          <div class="chat-info">
            <span v-if="members.users.length" @click="showMembersToggle('inroom')">
              <i
                :class="{ active: showMembers.inroom }"
                class="arrow-down"
              />
              <strong>{{ room.title ? room.title : 'В комнате' }}</strong>:
              {{ members.users.length }}
            </span>
            <span>
              &middot;
            </span>
            <!-- <span @click="showMembersToggle('total')">
              <i
                :class="{ active: showMembers.total }"
                class="arrow-down"
              />
              Все: {{ members.total.count }}
            </span>
            <span>
              &middot;
            </span>-->
            <span v-if="globalChat" @click="showShare = !showShare">
              <!-- <i :class="{ active: showShare }" class="share" /> -->
              Друзья
            </span>
            <span v-if="globalChat">
              &middot;
            </span>
            <span @click="messages = []">
              <!-- <i :class="{ active: showShare }" class="clean" /> -->
              Очистить чат
            </span>
            <i v-if="!globalChat" @click="mute = !mute" :class="{ active: mute }" class="mute" title="Выключить звук уведомлений" />
          </div>
          <transition name="toBottom">
            <div v-if="showShare && userFriends.length" class="friends">
              <strong>Список друзей:</strong>
              <label v-for="user in userFriends" :key="`chat-friends-${user._id}`" :for="user._id">
                <input :id="user._id" type="checkbox">
                <span class="avatar">
                  <img :src="user.photo" :alt="user.name">
                </span>
                {{ user.name }}
              </label>
              <button @click="sendInvite" class="dbtn blue">Пригласить</button>
            </div>
            <div v-else-if="showShare && !userFriends.length" class="friends">
              <h4>Список друзей</h4>
              <p>
                У вас нет друзей &#128532; <nuxt-link to="/users" style="font-weight:bold;">Найти друга</nuxt-link>
              </p>
            </div>
          </transition>

          <transition name="toBottom">
            <div v-if="showMembers.inroom" class="members-list">
              <strong>Сейчас в комнате:</strong>
              <!-- <div v-if="members.guests">
                Гости {{ members.guests }}
              </div> -->
              <ul>
                <li
                  v-for="m in members.users"
                  :key="`chat-member-${m.user.id}`"
                  :data-user="m.user.id"
                  @mouseenter="showUserModal(m.user.id, 'grid')"
                  @mouseleave="showUserModal(m.user.id, 'none')"
                  :style="{ cursor: user && m.user.id !== user.id ? 'pointer' : 'default' }"
                >
                  <div class="avatar">
                    <img v-if="m.user.photo" :src="m.user.photo" :alt="m.user.name + ' avatar'">
                    <img v-else src="/no-avatar.png" :alt="m.user.name + ' avatar'">
                  </div>
                  {{ m.user.name.length > 20 ? `${m.user.name.slice(0, 17)}...` : m.user.name }}
                  <div
                    @mouseenter="showUserModal(m.user.id, 'grid')"
                    @mouseleave="showUserModal(m.user.id, 'none')"
                    class="modal"
                  >
                    <div class="avatar">
                      <img v-if="m.user.photo" :src="m.user.photo" :alt="m.user.name + ' avatar'">
                      <img v-else src="/no-avatar.png" :alt="m.user.name + ' avatar'">
                    </div>
                    <div v-if="!isBanned" class="actions">
                      <nuxt-link :to="`/users/${m.user.id}`">
                        {{ m.user.name.length > 20 ? `${m.user.name.slice(0, 17)}...` : m.user.name }}
                      </nuxt-link>
                      <button v-if="user && m.user.id !== user.id" @click="whisper(m.user)" class="pm">
                        ЛС
                      </button>
                      <!-- <button v-if="!globalChat &&
                        user &&
                        m.id !== user.id"
                        @click="callUser(m)"
                        class="calling"
                      >
                        Звонок
                      </button> -->
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </transition>

          <!-- <transition name="toBottom">
            <div v-if="showMembers.total" class="members-list">
              <strong>Участники:</strong>
              <div v-if="members.total.count - members.total.users.length">
                Гости {{ members.total.count - members.total.users.length }}
              </div>
              <ul>
                <li
                  v-for="m in members.users"
                  :key="`chat-member-total-${m.id}`"
                  :data-user="m.id"
                  @mouseenter="showUserModal(m.id, 'grid')"
                  @mouseleave="showUserModal(m.id, 'none')"
                  :style="{ cursor: user && m.id !== user.id ? 'pointer' : 'default' }"
                >
                  <div class="avatar">
                    <img v-if="m.photo" :src="m.photo" :alt="m.name + ' avatar'">
                    <img v-else src="/no-avatar.png" :alt="m.name + ' avatar'">
                  </div>
                  {{ m.name.length > 20 ? `${m.name.slice(0, 17)}...` : m.name }}
                  <div
                    @mouseenter="showUserModal(m.id, 'grid')"
                    @mouseleave="showUserModal(m.id, 'none')"
                    class="modal"
                  >
                    <div class="avatar">
                      <img v-if="m.photo" :src="m.photo" :alt="m.name + ' avatar'">
                      <img v-else src="/no-avatar.png" :alt="m.name + ' avatar'">
                    </div>
                    <div class="actions">
                      <nuxt-link :to="`/users/${m.id}`">
                        <strong>{{ m.name.length > 20 ? `${m.name.slice(0, 17)}...` : m.name }}</strong>
                      </nuxt-link>
                      <button v-if="user && m.id !== user.id" @click="whisper(m)" class="pm">
                        ЛС
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </transition> -->
          <div class="get-history">
            <button
              v-if="getHistoryVal && (globalChat || isChat)"
              @click="getHistory"
            >
              Загрузить историю
            </button>
          </div>
          <transition-group name="toLeft" tag="ul" class="messages">
            <li v-for="m in messages" :key="`chat-message-${m.date}`">
              <div
                :class="{ 'active': user ? user.id === m.user.id : '' }"
                class="message"
              >
                <div class="wrapper">
                  <div v-if="m.user">
                    <aura-component :user="m.user" />
                    <artifact-component v-if="m.user.artifact" :user="m.user" />
                  </div>
                  <div :class="`${m.user.aura_color ? `aura-color-${m.user.aura_color}` : ''} ${m.user.gender ? `gender-${m.user.gender}` : ''}`" class="avatar">
                    <img v-if="m.user.photo" :src="m.user.photo || '/no-avatar.png'" :alt="m.user.name">
                  </div>
                </div>
                <div class="body">
                  <b v-if="(m.pm && user) && m.pm.id === user.id" style="color:deeppink;">
                    [Вам пишет, <nuxt-link :to="`/users/${m.user.id}`">{{ m.user.name }}</nuxt-link>]
                  </b>
                  <b v-else-if="(m.pm && user) && m.user.id === user.id" style="color:deeppink;">
                    [Вы пишите, <nuxt-link :to="`/users/${m.user.id}`">{{ m.pm.name }}</nuxt-link>]
                  </b>
                  <b v-else>
                    {{ room.id === 'global' ? `[Общая комната: ` : '' }}
                    <nuxt-link
                      :to="`/users/${m.user.id}`"
                      :style="`${m.user.nickname_color ? `color: ${m.user.nickname_color}` : ''}`"
                    >{{ m.user.name }}</nuxt-link>{{ room.id === 'global' ? `]` : '' }}
                  </b>
                  <!-- <sup v-if="room.owner === m.user.id" class="green" title="Владелец комнаты">Владелец</sup> -->
                  <sup v-if="m.user.group === 0" class="green" title="Администратор">Аdm</sup>
                  <sup v-else-if="m.user.group === -1" class="red" title="Бот">Бот</sup>
                  <time v-if="m.date" :title="m.date">{{ m.date | filterTime }}</time>
                  <p>{{ m.text }}</p>
                  <div v-if="user && m.user.id !== null && user.id !== m.user.id" class="footer">
                    <span @click="reply(m.user.name)">Обратиться</span>
                    <span @click="whisper(m.user)" title="Личное сообщение">ЛС</span>
                    <span v-if="!spamMembersList.includes(m.user.id)" @click="spamMember(m)">Жалоба</span>
                    <span v-if="banMembersList.includes(m.user.id) && (user.group === 0 || room.owner === user.id)" @click="unbanMember(m)">Разблокировать</span>
                    <span v-else-if="!banMembersList.includes(m.user.id) && (user.group === 0 || room.owner === user.id)" @click="banMember(m)">Заблокировать</span>
                  </div>
                </div>
              </div>
            </li>
          </transition-group>

          <div>
            <div v-if="!user" @click="login" class="chat-login">
              <strong>Войти на сайт</strong>
            </div>
            <div v-else-if="adBlock" class="chat-login">
              <strong>
               Доступ к чату ограничен.
                <nuxt-link to="/adblock">Отключите AdBlock</nuxt-link>
              </strong>
            </div>
            <div v-else-if="isBanned" class="chat-login">
              <strong>Вам запрещен доступ к чату</strong>
            </div>
            <div
              v-else-if="user && !isBanned"
              class="create-message"
            >
              <span v-if="pm" class="pm">
                {{ pm.name.length > 7 ? `${pm.name.slice(0, 4)}...` : pm.name }}
                <i @click="whisperCancel" />
              </span>
              <div class="input">
                <input
                  ref="chatInputMsg"
                  v-model="message"
                  class="input-message"
                  type="text"
                  maxlength="300"
                  placeholder="Ваше сообщение"
                  @keyup.enter="sendMessage"
                  @focus="detectInputEnter(true)"
                  @blur="detectInputEnter(false)"
                >
                <i
                  @click="showSmiles = !showSmiles"
                  class="icon-message-smile"
                  :class="{ active: showSmiles }"
                  title="Эмоции"
                />
                <i
                  @click="sendMessage"
                  class="icon-message-send"
                  title="Отправка по нажатию Enter"
                />
              </div>
            </div>

            <transition name="toTop">
              <div v-if="showSmiles" class="chat-smiles">
                <i
                  @click="showSmiles = !showSmiles"
                  class="icon-close"
                  title="Закрыть"
                />
                <div class="emoji-list">
                  <img
                    v-for="item in emoji[smilesCat]"
                    :key="`chat-emoji-${item}`"
                    :data-src="`/static_files/onion/${item}.gif`"
                    @click="appendEmoji(item)"
                    src="/static_files/no-poster.png"
                    class="lazyload"
                    :class="{ big: smilesCat === 'mafu' || smilesCat === 'anityanochki' }"
                  />
                </div>
                <div class="emoji-cats">
                  <span @click="smilesCat = 'onion'" :class="{ active: smilesCat === 'onion' }">
                    <img src="/static_files/onion/_).gif" alt="">
                  </span>
                  <span @click="smilesCat = 'mafu'" :class="{ active: smilesCat === 'mafu' }">
                    <img src="/static_files/onion/mafu_relaxed.gif" alt="">
                  </span>
                  <span @click="smilesCat = 'anityanochki'" :class="{ active: smilesCat === 'anityanochki' }">
                    <img src="/static_files/onion/anityanochki_dancer_3.gif" alt="">
                  </span>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </transition>

    <div v-if="notifications.length" class="push-notifications">
      <span v-if="notifications.length > 1" @click="notifications = []" class="clear">Закрыть все</span>
      <transition-group name="toTop" tag="div" class="list">
        <div v-for="item in notifications" :key="`push-${item.date}`" :data-push-id="item.date" class="item">
          <div class="body">
            <div class="avatar">
              <img :src="item.from.photo" alt="">
            </div>
            <div>
              <div class="header">
                <nuxt-link :to="`/users/${item.from.id}`">
                  {{ item.from.name }}
                </nuxt-link>
                <!-- <time>{{ item.date }}</time> -->
                <i @click="removePush(item.date)" class="close" />
              </div>
              <p>{{ item.message }}</p>
            </div>
          </div>

          <div>
            <div v-if="item.type === 'pm'">
              <button @click="whisper(item.from)" class="dbtn green">Личное сообщение</button>
              <button @click="sendPMUser = item.from.id" class="dbtn">Написать письмо</button>
            </div>
            <div v-else-if="item.type === 'open_profile'">
              <button @click="switchProfileType(item.date)" class="dbtn green">Открыть профиль</button>
              <button @click="sendPMUser = item.from.id" class="dbtn">Написать письмо</button>
            </div>
            <div v-else-if="item.type === 'friendly'">
              <button @click="approveFriend(item.date, item)" class="dbtn green">Подружиться</button>
              <button @click="sendPMUser = item.from.id" class="dbtn">Написать письмо</button>
            </div>
            <div v-else-if="item.type === 'invite_cinema'">
              <button @click="goToCinema(item.payload.event_id)" class="dbtn green">Принять</button>
              <button @click="removePush(item.date)" class="dbtn">Отклонить</button>
            </div>
            <div v-else-if="item.type === 'invite_room'">
              <button @click="goToRoom(item.payload)" class="dbtn green">В комнату</button>
              <button @click="sendPMUser = item.from.id" class="dbtn">Написать письмо</button>
            </div>
            <div v-else-if="item.type === 'friendly_approve'">
              <button @click="whisper(item.from)" class="dbtn">Личное сообщение</button>
            </div>
            <div v-else-if="item.type === 'comment_reply'">
              <button @click="goToPage(item.payload.comment_id)" class="dbtn">Прочитать</button>
            </div>
            <div v-else-if="item.type === 'first_pet'">
              <button @click="goToStore" class="dbtn blue">Перейти в Магазин за покупками</button>
            </div>
            <div v-else-if="item.type === 'invite_roulette'">
              <p>{{ rouletteTimer }} сек. на ответ</p>
              <button @click="rouletteAnswer('reject', item)" class="dbtn red">Отклонить</button>
              <button @click="rouletteAnswer('resolve', item)" class="dbtn green">Принять</button>
            </div>
          </div>
        </div>
      </transition-group>
    </div>

    <transition name="fade">
      <div v-if="sendPMUser" class="popup">
        <div class="modal">
          <div class="action">
            <i @click="sendPMUser = null" class="close" />
          </div>
          <div class="body">
            <h4>Письмо</h4>
            <textarea v-model="PMtext" />
            <button @click="sendPM">Отправить</button>
            <span @click="sendPMUser = null">Отмена</span>
          </div>
        </div>
      </div>
    </transition>

    <!-- <div v-if="calledUser" class="peerjs-modal">
      <div>
        <h2>Звонок пользователю {{ calledUser.name }}</h2>
        <i @click="calledUser = null" class="close" />
      </div>
      <div class="poster">
        <img :src="calledUser.photo" alt="">
      </div>
      <div>
        <button @click="callInit(calledUser, 'audio')" class="dbtn blue">
          Аудио
        </button>
        <button @click="callInit(calledUser, 'video')" class="dbtn green">
          Видео
        </button>
      </div>
    </div>

    <div v-if="outgoingCall" class="call-notification">
      <div class="call-header">
        Исходящий {{ outgoingCall.type === 'audio' ? 'аудио-' : 'видео-' }} звонок {{ outgoingCall.from.name }}
      </div>
      <div v-if="!callProgress" class="body">
        <nuxt-link :to="`/users/${outgoingCall.from.id}`">
          <img :src="outgoingCall.from.photo" alt="">
        </nuxt-link>
        <span>
          Ожидаем ответа
        </span>
        <button @click="callReject({ socket_id: outgoingCall.to.socket_id, error: null })" class="reject">
          Завершить
        </button>
      </div>
      <div v-else-if="callProgress" class="body">
        <nuxt-link :to="`/users/${outgoingCall.from.id}`">
          <img :src="outgoingCall.from.photo" alt="">
        </nuxt-link>
        <span>
          Сеанс {{ callProgress }}
        </span>
        <button @click="callReject({ socket_id: outgoingCall.to.socket_id, error: null })" class="reject">
          Завершить
        </button>
      </div>
    </div>
    <div v-else-if="incomingCall" class="call-notification">
      <div class="call-header">
        Входящий {{ incomingCall.type === 'audio' ? 'аудио-' : 'видео-' }} звонок от {{ incomingCall.from.name }}
      </div>
      <div v-if="!callProgress" class="body">
        <nuxt-link :to="`/users/${incomingCall.from.id}`">
          <img :src="incomingCall.from.photo" alt="">
        </nuxt-link>
        <button @click="callResolve(incomingCall)" class="resolve">
          Ответить
        </button>
        <button @click="callReject({ socket_id: incomingCall.from.socket_id, error: null })" class="reject">
          Отклонить
        </button>
      </div>
      <div v-else-if="callProgress" class="body">
        <nuxt-link :to="`/users/${incomingCall.from.id}`">
          <img :src="incomingCall.from.photo" alt="">
        </nuxt-link>
        <span>
          Сеанс {{ callProgress }}
        </span>
        <button @click="callReject(incomingCall.from.socket_id)" class="reject">
          Завершить
        </button>
      </div>
    </div>

    <video v-show="videoCall" autoplay muted id="local-video"></video>
    <video v-show="videoCall" autoplay id="remote-video"></video> -->

    <!-- <peerjs-component v-if="loadPeerJS" :payload="loadPeerJS" /> -->
    <div v-if="showOnBlurNotifi" class="on-blur-notifi">
      <div class="modal">
        <i @click="showOnBlurNotifi = false" class="close" />
        <div class="body">
          <h3>Мы вас уже потеряли</h3>
          <p>
            Вкладка не активна длительное время.
            <!-- Получение событий от сервера приостановлено. -->
            Оставьте одну активную вкладку сайта и обновите страницу.
          </p>
          <button @click="showOnBlurNotifi = false">Ок, понятно</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

/* eslint-disable */
// let mpTimeout = null
let mountedIndexChat = null

// function makeNewPosition($container) {
//   const h = $container.height() - 50;
//   const w = $container.width() - 50;

//   const nh = Math.floor(Math.random() * h);
//   const nw = Math.floor(Math.random() * w);

//   return [nh, nw];
// }

// function animateDiv($target) {
//   const newq = makeNewPosition($target.parent());
//   const oldq = $target.offset();
//   const speed = calcSpeed([oldq.top, oldq.left], newq);

//   $target.animate({
//     top: newq[0],
//     left: newq[1]
//   }, speed, function() {
//     animateDiv($target);
//   });
// };

// function calcSpeed(prev, next) {
//   const x = Math.abs(prev[1] - next[1]);
//   const y = Math.abs(prev[0] - next[0]);

//   const greatest = x > y ? x : y;

//   const speedModifier = 0.1;

//   const speed = Math.ceil(greatest / speedModifier);

//   return speed;
// }

export default {
  props: { event: { type: Object, require: true, default: () => ({ id: null, owner: null }) } },
  components: {
    // peerjsComponent: () => import('~/components/peerjsComponent.vue'),
    auraComponent: () => import('~/components/auraComponent.vue'),
    artifactComponent: () => import('~/components/artifactComponent.vue')
  },
  filters: {
    filterTime(value) {
      const hour =
        new Date(value).getHours() >= 10
          ? new Date(value).getHours()
          : '0' + new Date(value).getHours()
      const min =
        new Date(value).getMinutes() >= 10
          ? new Date(value).getMinutes()
          : '0' + new Date(value).getMinutes()
      const sec =
        new Date(value).getSeconds() >= 10
          ? new Date(value).getSeconds()
          : '0' + new Date(value).getSeconds()
      return `${hour}:${min}:${sec}`
    },
    filterDate(value) {
      const months = [
        'янв',
        'фев',
        'мар',
        'апр',
        'мая',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек'
      ]
      const day = new Date(value).getDate()
      const month = new Date(value).getMonth()
      const hour =
        new Date(value).getHours() >= 10
          ? new Date(value).getHours()
          : '0' + new Date(value).getHours()
      const min =
        new Date(value).getMinutes() >= 10
          ? new Date(value).getMinutes()
          : '0' + new Date(value).getMinutes()
      return `${day} ${months[month]} ${hour}:${min}`
    }
  },
  watch: {
    tabActive(val) {
      if (!val) {
        this.routeLeave()
      } else {
        this.routeEnter()
      }
    },
    inviteToStream(val) {
      if (val) {
        const dateDay = new Date().getFullYear() + '-' + new Date().getMonth() + '-' + new Date().getMonth()
        if (localStorage.getItem(`invite_to_stream_${val.film.title_ru}_${dateDay}`)) return

        const obj = {
          date: Date.now(),
          room: 'global',
          text:
`Залетай к нам на стрим "${val.film.title_ru}", пообщаемся! [::link="https://anime777.ru/tv"::]Смотреть[::/link::].
Пс. слышно, но не видно? [::link="https://anime777.ru/adblock"::]Отключите AdBlock[::/link::]!`,
          user: {
            id: val.owner,
            name: val.film.title_en,
            photo: val.film.poster,
            group: 1
          }
        }
        this.messages.push(obj)

        ++this.messagesUnread

        // if (!this.mute && this.$refs.chatNotifi) this.$refs.chatNotifi.play()

        this.$nextTick(() => this.parseBB())

        localStorage.setItem(`invite_to_stream_${val.film.title_ru}_${dateDay}`, 'true')
      }
    },
    showOnBlurNotifi(val) {
      console.log('showOnBlurNotifi', val)
      if (!val) location.reload()
    },
    showChat(val) {
      if (val) {
        // this.genMembers(this.membersD)
        clearInterval(this.toggleTotalInterval)
        this.toggleTotalInterval = null
        const totalElem = document.querySelector('.total span')
        if (totalElem) {
          totalElem.textContent = this.isDesktop ? 'Количество участников онлайн' : 'Участники онлайн'
        }
      } else {
        this.showMembers = {
          total: false,
          inroom: false
        }
      }
    },
    whisperStore() {
      if (this.whisperStore) this.whisper(this.whisperStore)
    },
    showShare() {
      if (this.user && this.showShare) this.getFriendList()
    },
    // user() {
    //   this.initialize()
    // },
    changeRoute() {
      this.onFocus()
      if (this.titleInterval) clearInterval(this.titleInterval)

      this.globalChat = !(
        this.$route.name === 'tv' ||
        this.$route.name === 'cinema-id' ||
        this.$route.name === 'chat'
      )

      this.isChat = this.$route.name === 'chat'

      this.showChat = !this.globalChat

      if (!this.isDesktop) {
        this.showChat = false
        this.showMembers = {
          total: false,
          inroom: false
        }
      }
    },
    sendPMUser() {
      if (this.sendPMUser) {
        this.$nextTick(() => {
          const modal = document.querySelector('.popup .modal')
          if (modal) {
            modal.style.marginTop = `-${modal.offsetHeight / 2}px`
          }
        })
      }
    },
    smilesCat(val) {
      setTimeout(() => {
        const smilesList = document.querySelector('.emoji-list')
        if (smilesList) {
          this.lazyLoadImgs()
          smilesList.removeEventListener('scroll', this.lazyLoadImgs)
          smilesList.addEventListener('scroll', this.lazyLoadImgs)
        }
      }, 1000)
    },
    showSmiles(val) {
      setTimeout(() => {
        const smilesList = document.querySelector('.emoji-list')
        if (smilesList) {
          this.lazyLoadImgs()
          smilesList.removeEventListener('scroll', this.lazyLoadImgs)
          smilesList.addEventListener('scroll', this.lazyLoadImgs)
        }
      }, 1000)
    }
  },
  computed: {
    ...mapState(['user', 'isDesktop', 'whisperStore', 'inviteToStream', 'tabActive']),
    changeRoute() {
      return this.$route.fullPath
    }
  },
  data() {
    const emoji = {
      onion: [
        '_)', '_D', '_-D', '_lol_', '_ololo_', '_evil_', '+_+', '_cool_', '_thumbup_',
        '_yahoo_', '_tea2_', '_star_', '_oh_', '_shy_', '_shy2_', '_hurray_', '_-P',
        '_roll_', '_!_', '_watching_', '_love_', '_love2_', '_bunch_', '_perveted_',
        '_(', '_very-sad_', '_depressed_', '_depressed2_', '_hopeless_', '_very-sad2_',
        '_-(', '_cry_', '_cry6_', '_Cry2_', '_Cry3_', '_Cry4_', '_-o', '_shock_',
        '_shock2_', '_scream_', '_dont-want_', '_noooo_', '_scared_', '_shocked2_',
        '_shocked3_', '_shocked4_', '_tea-shock_', '_frozen3_', '_angry4_', '_revenge_',
        '_evil2_', '_twisted_', '_angry_', '_angry3_', '_angry5_', '_angry6_', '_cold_',
        '_strange4_', '_ball_', '_evil3_', '_8)_', '_oh2_', '_ooph_', '_wink_',
        '_dunno_', '_dont-listen_', '_hypno_', '_advise_', '_bored_', '_disappointment_',
        '_hunf_', '_hot_', '_hot2_', '_hot3_', '_stress_', '_strange3_', '_strange2_',
        '_strange1_', '_Bath2_', '_strange_', '_hope_', '_hope3_', '_diplom_', '_hi_',
        '_bye_', '_sleep_', '_bow_', '_Warning_', '_Ban_', '_Im-dead_', '_sick_', '_s1_',
        '_s3_', '_s2_', '_happy_cry_', '_ill_', '_sad2_', '_bullied_', '_bdl2_',
        '_Happy-Birthday_', '_flute_', '_cry5_', '_gaze_', '_hope2_', '_sleepy_',
        '_study_', '_study2_', '_study3_', '_gamer_', '_animal_', '_caterpillar_',
        '_cold2_', '_shocked_', '_frozen_', '_frozen2_', '_kia_', '_interested_',
        '_happy_', '_happy3_', '_water_', '_dance_', '_liar_', '_prcl_', '_play_',
        '_s4_', '_s_', '_bath_', '_kiss_', '_whip_', '_relax_', '_smoker_', '_smoker2_',
        '_bdl_', '_cool2_', '_V_', '_V2_', '_V3_', '_sarcasm_', '_angry2_', '_kya_'
      ],
      mafu: [
        'mafu_relaxed', 'mafu_sob', 'mafu_yum', 'mafu_see_no_evil', 'mafu_rage',
        'mafu_pray', 'mafu_ghos', 'mafu_kissing_closed_eyes', 'mafu_heart_eyes',
        'mafu_relaxed_2', 'mafu_stuck_out_tongue_closed_eyes', 'mafu_sob_2',
        'mafu_curry', 'mafu_pray_2', 'mafu_sleeping', 'mafu_heart_eyes_2',
        'mafu_ok_hand', 'mafu_unamused'
      ],
      anityanochki: [
        'anityanochki_sob_3', 'anityanochki_two_hearts',
        'anityanochki_two_hearts_2', 'anityanochki_two_hearts_3', 'anityanochki_wastebasket',
        'anityanochki_wave', 'anityanochki_wink', 'anityanochki_wink_2', 'anityanochki_+1',
        'anityanochki_+1_2', 'anityanochki_alarm_clock', 'anityanochki_beer', 'anityanochki_blush',
        'anityanochki_clap', 'anityanochki_crossed_fingers', 'anityanochki_cry', 'anityanochki_cry_2',
        'anityanochki_dancer', 'anityanochki_dancer_2', 'anityanochki_dancer_3',
        'anityanochki_dancer_4', 'anityanochki_facepunch', 'anityanochki_flushed',
        'anityanochki_foxi', 'anityanochki_handshake', 'anityanochki_headphones',
        'anityanochki_heart', 'anityanochki_heart_2', 'anityanochki_heart_3',
        'anityanochki_heart_4', 'anityanochki_heart_5',
        'anityanochki_hugs', 'anityanochki_joy', 'anityanochki_man_facepalming',
        'anityanochki_nerd_face', 'anityanochki_no_mouth', 'anityanochki_ok_hand',
        'anityanochki_ok_hand_2',
        'anityanochki_open_hands', 'anityanochki_pleading', 'anityanochki_point_left',
        'anityanochki_policewoman', 'anityanochki_popcorn', 'anityanochki_rainbow_flag',
        'anityanochki_scream', 'anityanochki_scream_2', 'anityanochki_slightly_smiling_face',
        'anityanochki_sob', 'anityanochki_sob_2'
      ]
    }

    const route = this.$route
    const globalChat = !(
      route.name === 'tv' ||
      route.name === 'cinema-id' ||
      route.name === 'chat'
    )

    let room = { id: 'global', owner: null, title: 'Общая' }
    let messages = []

    if (this.event.id) {
      room = this.event
    }

    return {
      onlineInterval: null,

      smilesCat: 'onion',

      call: null,
      peer: null,
      peeId: null,

      videoCall: false,

      callProgress: 0,

      callProgressInterval: null,

      incomingCall: null,
      outgoingCall: null,

      calledUser: null,

      socketId: null,
      resizeChat: false,
      mute: false,
      room,
      roomCreated: null,
      roomsList: [],
      createRoomTitle: '',
      createRoomHidden: false,
      createRoomPoster: null,
      showCreateRoom: false,
      isBanned: false,
      showMembers: {
        total: false,
        inroom: false
      },
      globalChat,
      isChat: route.name === 'chat',
      showChat: !globalChat,
      messages,
      message: '',
      pm: null,
      emoji,
      showSmiles: false,
      membersD: null,
      members: {
        users: [],
        count: 0
      },
      // members: {
      //   total: {
      //     users: [],
      //     count: 0
      //   },
      //   users: [],
      //   guests: 0
      // },
      messagesUnread: 0,
      gets: {},
      pageTitle: null,
      notifications: [],
      sendPMUser: null,
      PMtext: '',
      userFriends: [],
      showShare: false,
      showRoomsList: false,
      spamMembersList: [],
      banMembersList: [],
      titleInterval: null,
      messagesPush: [],
      adBlock: false,
      rouletteTimetInverval: null,
      rouletteTimer: 30,
      onBlurTime: 0,
      onBlurTimeout: null,
      showOnBlurNotifi: false,
      playerStart: false,
      toggleTotalInterval: null,
      showChatRead: false,
      getHistoryVal: true
    }
  },
  mounted() {
    // this.peer = new this.$Peer({ config: { 'iceServers': process.env.iceServers } })
    // this.peer.on('open', (peerID) => {
    //   this.peerId = peerID
    //   // console.log('peerID', this.peerId)
    // })

    // this.$socket.on('an:call:init', data => {
    //   // console.log('an:call:init', data)
    //   if (this.call || this.mute) {
    //     this.$socket.emit('an:call:talking', data.from.socket_id)
    //     return
    //   }
    //   this.incomingCall = data
    //   this.$refs.incoming.play()
    // })

    // this.$socket.on('an:call:talking', () => {
    //   this.outgoingCall = null
    //   this.$refs.calling.pause()
    //   this.$store.commit('setError', { status: 'info', msg: 'Пользователь разговаривает' })
    //   setTimeout(() => this.$store.commit('clearError'), 2000)
    // })

    // this.$socket.on('an:call:resolve', (data) => {
    //   // console.log('an:call:resolve', data)

    //   this.peerAnswer(data)

    //   this.$refs.calling.pause()

    //   this.callProgressInterval = setInterval(() => ++this.callProgress, 1000)
    // })

    // this.$socket.on('an:call:reject', (data) => {
    //   this.callReject(data)
    // })

    // console.log('mounted', this.changeRoute)

    // setTimeout(() => {
    //   if (this.user && this.user.group !== 777) {
    //     const iframe = document.querySelector('.asense iframe')
    //     console.log('iframe', iframe)
    //     if (!iframe) {
    //       this.adBlock = true
    //     }
    //   }
    // }, 2000)

    // this.$socket.off('an:reconnect')
    // this.$socket.off('an:timeout')

    // this.$socket.on('an:timeout', (members, cb) => {
    //   this.members = members

    //   cb(this.showOnBlurNotifi)

    //   if (this.showOnBlurNotifi) this.$socket.off('an:timeout')
    // })

    console.log('chat mounted', Date.now())
    // if (mountedIndexChat === this.$route.fullPath) return
    // mountedIndexChat = this.$route.fullPath

    this.pageTitle = document.title
    
    if (!localStorage.getItem('hello_msg')) {
      setTimeout(() => {
        const obj = {
          date: Date.now(),
          room: 'global',
          text:
`Йо! Ты впервые на нашем сайте? Это чат, здесь ты можешь пообщаться с другими участниками сайта.
Скажу по секрету, за регистрацию ты получишь своего личного покемона и Premium подписку!
Кратко о сайте: у нас ты можешь смотреть аниме онлайн, читать комиксы манга и ранобэ новеллы,
все на русском (и оригинал + сабы)! Также аниме можно смотреть в комнатах совместно с друзьями! Это и многое другое
ты можешь найти в верхнем меню, используй его, тебе понравится!
`,
          user: {
            id: null,
            name: 'Bot',
            photo: '/static_files/items/pet-0.svg',
            group: -1
          }
        }
        this.messages.push(obj)

        ++this.messagesUnread

        // if (!this.mute && this.$refs.chatNotifi) this.$refs.chatNotifi.play()

        localStorage.setItem('hello_msg', 'true')

        this.toggleTotal()
      }, 10 * 1000)
    }

    const dateDay = new Date().getFullYear() + '-' + new Date().getMonth() + '-' + new Date().getDate()
    if (!localStorage.getItem(`adblock_${dateDay}`)) {
      setTimeout(() => {
        this.detectAdBlock()
        localStorage.setItem(`adblock_${dateDay}`, 'true')
      }, 30 * 1000)
    }

    this.routeEnter()
  },
  // beforeDestroy() {
  //   this.routeLeave()
  // },
  methods: {
    routeLeave() {
      mountedIndexChat = null

      // window.removeEventListener('blur', this.onBlur)
      // window.removeEventListener('focus', this.onFocus)
      window.removeEventListener('message', this.kodikMessageListener)

      const obj = {
        room: this.room.id,
        user: null
      }

      if (this.user) {
        obj.user = {
          id: this.user.id,
          name: this.user.name || 'No name',
          photo: this.user.photo || '/no-avatar.svg',
          group: this.user.group,
          aura_color: this.user.aura_color,
          pet: this.user.pet
        }
      }

      this.$socket.emit('an:user:leave', obj, (cb) => {})
    },
    routeEnter() {
      const obj = {
        room: this.room.id,
        user: null
      }

      if (this.user) {
        obj.user = {
          id: this.user.id,
          name: this.user.name || 'No name',
          photo: this.user.photo || '/no-avatar.svg',
          group: this.user.group,
          gender: this.user.gender,
          aura_color: this.user.aura_color,
          pet: this.user.pet
        }
      }
      
      this.$socket.emit('an:user:leave', obj, () => {
        // window.removeEventListener('blur', this.onBlur)
        // window.removeEventListener('focus', this.onFocus)
        window.removeEventListener('message', this.kodikMessageListener)

        this.$socket.off('an:notification')
        // this.$socket.off('an:roulette:answer')
        this.$socket.off('an:user:ban')
        this.$socket.off('an:user:unban')
        this.$socket.off('an:message:new')
        this.$socket.off('an:message:push')
        this.$socket.off('an:members')

        this.$socket.on('an:members', members => {
          this.members = members
        })

        this.$socket.emit('an:user:join', obj, (data) => {
          if (data.isBanned.error) {
            this.isBanned = true
          }

          this.members = data.members

          this.messages = data.messages

          const message = {
            text: `Рекомендуем посетить сайт разработчика.
Там вы найдете другие наши проекты [::link="https://r0n1x.ru"::]r0n1x.ru[::/link::].
Наш новый сервис для совместного просмотра аниме [::link="https://animeast.ru"::]animeast.ru[::/link::].
Минимум лишнего максимум функционала!`,
            user: {
              id: null,
              name: 'Bot',
              photo: '/bot-avatar.png',
              group: -1
            }
          }
          this.messages.push(message)

          this.$nextTick(() => this.parseBB())

          this.socketId = data.socket_id

          if (window.addEventListener) {
            window.addEventListener('message', this.kodikMessageListener);
          } else {
            window.attachEvent('onmessage', this.kodikMessageListener);
          }

          // window.addEventListener('blur', this.onBlur)
          // window.addEventListener('focus', this.onFocus)

          this.$socket.on('an:notification', (data) => {
            // console.log('notification data', data)
            this.notifications.push(data)
            if (!this.mute && this.$refs.chatNotifi) this.$refs.chatNotifi.play()

            if (data.type === 'invite_roulette') {
              this.rouletteTimerInverval = setInterval(() => {
                if (this.rouletteTimer) {
                  --this.rouletteTimer
                } else {
                  clearInterval(this.rouletteTimerInverval)
                  this.rouletteAnswer('reject', { from: data.from })
                }
              }, 1000)
            }
          })

          this.$socket.on('an:roulette:answer', data => {
            // console.log(data)
            if (data.response === 'resolve') {
              setTimeout(() => {
                this.goToRoom(data.room)
              }, 2000)
            }
          })

          this.$socket.on('an:user:unban', (data) => {
            this.messages.push(data)
            this.isBanned = false
            this.parseBB()
          })

          this.$socket.on('an:user:ban', (data) => {
            this.messages.push(data)
            this.isBanned = true
            this.parseBB()
          })

          this.$socket.on('an:message:push', (data) => {
            // console.log('an:message:push', data)
            // mpTimeout = null
            if (this.mute) return
            // this.messagesPush = null
            this.$nextTick(() => {
              this.messagesPush.push(data)
              setTimeout(() => {
                const newArr = this.messagesPush.filter(el => el.message.date !== data.message.date)
                this.messagesPush = newArr
                this.parseBB()
              }, 5 * 1000)
            })
          })

          this.$socket.on('an:message:new', (message) => {
            // console.log('message:new', message)
            this.toggleTotal()

            this.messages.push(message)
            if (!this.showChat) {
              ++this.messagesUnread
              this.newMsgTitle()
              if (!this.user || this.user.id !== message.user.id) {
                if (!this.mute && this.$refs.chatNotifi) this.$refs.chatNotifi.play()
              }
            } else {
              if (this.user && this.user.id !== message.user.id) {
                if (
                  !this.mute &&
                  this.$refs.chatNotifi &&
                  this.onBlurTimeout
                ) {
                  this.$refs.chatNotifi.play()
                }
              }
            }
            this.$nextTick(() => this.parseBB())
          })
        })
      })
    },
    newMsgTitle() {
      if (!this.user) return
      const pageTitle = this.getPageTitle()
      clearInterval(this.titleInterval)
      this.titleInterval = setInterval(() => {
        if (!document.title.includes('сообщение')) {
          document.title = `${this.messagesUnread} сообщение`
        } else {
          document.title = pageTitle
        }
      }, 1000)
    },
    detectAdBlock() {
      const iframe = document.querySelector('.asense iframe')

      if (
        (!iframe && !this.user) ||
        (!iframe && this.user && this.user.group !== 777)
      ) {
        const obj = {
          date: Date.now(),
          room: 'global',
          text:
`Кажется у вас установлен блокировщик рекламы. Сайт может работать некорректно: низкое качество видео,
проблемы синхронизации при совместном просмотре, отсутствующие изображения глав манги,
недоступные картинки в ранобэ и в других разделах сайта. Если вам понравился проект, пожалуйста, отключите AdBlock.
Этим вы поможете не только нам, но и себе. Благодарим за понимание.
[::link="https://anime777.ru/adblock"::]Как отключить AdBlock[::/link::]`,
          user: {
            id: null,
            name: 'Bot',
            photo: '/static_files/items/pet-0.svg',
            group: -1
          }
        }
        this.messages.push(obj)

        ++this.messagesUnread

        // if (!this.mute && this.$refs.chatNotifi) this.$refs.chatNotifi.play()

        this.toggleTotal()

        this.$nextTick(() => this.parseBB())
      }
    },
    toggleTotal() {
      clearInterval(this.toggleTotalInterval)
      this.toggleTotalInterval = setInterval(() => {
        this.showChatRead = !this.showChatRead
      }, 1500)
    },
    kodikMessageListener(message) {
      // console.log('kodikMessageListener', message.data)
      if (message.data && message.data.key) {
        if (
          message.data.key === 'kodik_player_pause' ||
          message.data.key === 'kodik_player_video_ended'
        ) {
          this.playerStart = false
        } else if (message.data.key.includes('kodik_player')) {
          this.playerStart = true
        }
      }
    },
    onBlurNotifi() {
      if (this.playerStart) {
        // console.log('player start', this.playerStart)
        return
      }

      this.showOnBlurNotifi = true

      this.$socket.off('an:user:ban')
      this.$socket.off('an:user:unban')
      this.$socket.off('an:message:new')
      this.$socket.off('an:message:push')
      this.$socket.off('an:members')
      this.$socket.off('an:notification')
      this.$socket.off('an:roulette:answer')

      // this.$socket.off('an:call:init')
      // this.$socket.off('an:call:resolve')
      // this.$socket.off('an:call:reject')
      // this.$socket.off('an:call:talking')

      // clearInterval(this.onlineInterval)

      clearTimeout(this.onBlurTimeout)
      this.onBlurTimeout = null

      window.removeEventListener('blur', this.onBlur)
      window.removeEventListener('focus', this.onFocus)
    },
    onBlur() {
      // console.log('onBlur Tab')

      this.onBlurTimeout = setTimeout(() => {
        this.onBlurNotifi()
      }, 4 * 60 * 60 * 1000)
    },
    onFocus() {
      // console.log('onFocus Tab')

      clearTimeout(this.onBlurTimeout)
      this.onBlurTimeout = null
      this.playerStart = false

      // this.getOnline(this.room.id)
    },
    peerCall(data) {
      this.videoCall = data.type === 'video'
      const obj = { video: this.videoCall, audio: true }
      const getUserMedia = navigator.mediaDevices.getUserMedia
      getUserMedia(obj).then((stream) => {
        // console.log('peerCall obj', obj, stream)

        const localVideoElem = document.getElementById('local-video')
        localVideoElem.srcObject = stream

        setTimeout(() => {
          localVideoElem.play()
        }, 1000)

        this.call = this.peer.call(data.from.peer_id, stream);
        this.call.on('stream', (remoteStream) => {
          const remoteVideoElem = document.getElementById('remote-video')
          remoteVideoElem.srcObject = remoteStream

          setTimeout(() => {
            remoteVideoElem.play()
          }, 1000)
        });
      }).catch(error => {
        console.log('callResolve error', error)
        this.$socket.emit('an:call:reject', { socket_id: data.from.socket_id, error })
        this.$store.commit('setError', { status: 'warn', msg: error })
        setTimeout(() => this.$store.commit('clearError'), 3000)
        this.callReject({ socket_id: data.from.socket_id, error })
      })
    },
    peerAnswer(data) {
      // console.log('peerAnswer', data)
      this.peer.on('call', (call) => {
        // this.call = call
        this.videoCall = data.type === 'video'
        // console.log('call', call, this.videoCall)
        const obj = { video: this.videoCall, audio: true }
        const getUserMedia = navigator.mediaDevices.getUserMedia
        getUserMedia(obj).then((stream) => {
          const localVideoElem = document.getElementById('local-video')
          localVideoElem.srcObject = stream

          setTimeout(() => {
            localVideoElem.play()
          }, 1000)

          call.answer(stream); // Answer the call with an A/V stream.
          call.on('stream', (remoteStream) => {
            // console.log('peerAnswer stream', stream)
            const remoteVideoElem = document.getElementById('remote-video')
            remoteVideoElem.srcObject = remoteStream

            setTimeout(() => {
              remoteVideoElem.play()
            }, 1000)
          });
        }).catch(error => {
          console.log('peerAnswer error', error)
          this.$socket.emit('an:call:reject', { socket_id: data.to.socket_id, error })
          this.$store.commit('setError', { status: 'warn', msg: error })
          setTimeout(() => this.$store.commit('clearError'), 3000)
          this.callReject({ socket_id: data.to.socket_id, error })
        })
      })
    },
    callResolve(data) {
      // console.log('data', data)
      // this.incomingCall = null

      this.peerCall(data)

      data.to.peer_id = this.peerId

      this.$socket.emit('an:call:resolve', data)

      this.$refs.incoming.pause()
      this.callProgressInterval = setInterval(() => ++this.callProgress, 1000)
    },
    callReject(data) {
      // console.log('callReject', data)

      if (this.socketId !== data.socket_id) {
        this.$socket.emit('an:call:reject', { socket_id: data.socket_id, error: data.error })
      }

      if (this.call) {
        this.call.close()
        this.call = null
      }

      clearInterval(this.callProgressInterval)
      this.callProgress = 0
      this.incomingCall = null
      this.outgoingCall = null
      this.videoCall = false
      this.$refs.calling.pause()
      this.$refs.incoming.pause()
    },
    async callInit(user, type) {
      if (!this.user || this.call || this.outgoingCall) {
        return
      }
      // else if (this.user && this.user.group !== 777) {
      //   this.$store.commit('setError', { status: 'info', msg: 'Звонки доступны по подписке Premium+' })
      //   setTimeout(() => this.$store.commit('clearError'), 2000)
      //   return
      // }

      // if (!this.peerID) await this.peerInit(user, type)

      const obj = {
        type,
        to: {
          socket_id: user.socket_id,
          peer_id: null
        },
        from: {
          id: this.user.id,
          name: this.user.name,
          photo: this.user.photo,
          socket_id: this.socketId,
          peer_id: this.peerId
        }
      }

      this.outgoingCall = obj

      // console.log('callInit obj', obj)

      this.$socket.emit('an:call:init', obj)
      this.$refs.calling.play()
    },
    callUser(m) {
      this.calledUser = m
    },
    async rouletteAnswer(answer, obj) {
      // console.log('rouletteAnswer', answer, obj)

      if (answer === 'resolve') {
        const body = {
          owner: obj.from.id,
          title: `${obj.from.name} - ${this.user.name}`,
          hidden: true,
          poster: ''
        }

        const { data } = await this.$axios.post(`/api/rooms`, body)

        // console.log('rouletteAnswer data', data)

        if (data.error) {
          this.$store.commit('setError', { status: 'warn', msg: data.error.message })
          setTimeout(() => this.$store.commit('clearError'), 2000)
          return
        }

        const room = { _id: data._id, owner: data.owner, title: data.title }

        this.goToRoom(room)

        this.$socket.emit('an:roulette:answer', { to: obj.from.id, response: 'resolve', room })
      } else if (answer === 'reject') {
        this.$socket.emit('an:roulette:answer', { to: obj.from.id, response: 'reject' })
      }

      this.removePush(obj.date)
    },
    async getHistory() {
      this.getHistoryVal = false
      const { data } = await this.$axios.get(`/api/cinema/${this.room.id}/messages`)
      if (data.error) {
        this.$store.commit('setError', { status: 'info', msg: data.error.message })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else {
        const messages = this.messages.concat(data)
        this.messages = messages
        this.$nextTick(() => {
          this.parseBB()
          this.scrollChatMessages()
        })
      }
    },
    goToStore() {
      document.location.href = `/store`
    },
    detectInputEnter(enter) {
      if (this.isDesktop) return
      const iframe = document.querySelector('.event .event-iframe iframe')
      const chatInfo = document.querySelector('.chat .chat-area .chat-info')
      const chat = document.querySelector('.chat .chat-area .messages')
      const menu = document.querySelector('header.menu-main')
      if (enter) {
        chat.classList.add('focused')
        menu.style.display = 'none'
        setTimeout(() => {
          iframe ? iframe.scrollIntoView() : chatInfo.scrollIntoView()
          this.scrollChatMessages()
        }, 100)
      } else {
        chat.classList.remove('focused')
        menu.style.display = ''
      }
    },
    goToPage(id) {
      const routeName = id.slice(0, id.lastIndexOf('-'))
      const materialId = id.slice(id.lastIndexOf('-') + 1,)
      document.location.href = `/${routeName}/${materialId}`
    },
    showUserModal(id, action) {
      const elem = document.querySelector(`[data-user="${id}"] .modal`)
      if (elem) {
        elem.style.display = action
      }
    },
    petAnimated() {
      const petsList = document.querySelectorAll('.user-pet')
      for(let p = 0; p < petsList.length; p++) {
        /* eslint-disable */
        animateDiv($(petsList[p]))
      }
    },
    genMembers(data) {
      console.log('genMembers', data)
      this.membersD = data

      const rooms = data
      const roomId = this.room.id
      const members = { total: { users: [], count: 0 }, users: [], guests: 0 }

      if (rooms && Object.keys(rooms).length) {
        for(let i = 0; i < Object.keys(rooms).length; i++) {
          const room = Object.keys(rooms)[i]
          for(let j = 0; j < Object.keys(rooms[room]).length; j++) {
            const u = Object.keys(rooms[room])[j]
            const user = rooms[room][u]
            if (user && !members.total.users.find(el => el.id === user.id)) {
              members.total.users.push(user)
            }
            ++members.total.count
          }
        }

        if (this.showChat) {
          const usersInRoom = rooms[roomId]
          if (usersInRoom) {
            for(let i = 0; i < Object.keys(usersInRoom).length; i++) {
              const userSocket = Object.keys(usersInRoom)[i]
              const user = usersInRoom[userSocket]
              if (user) {
                if (!members.users.find(el => el.id === user.id)) {
                  user.socket_id = userSocket
                  members.users.push(user)
                }
              } else {
                ++members.guests
              }
            }
          }
          members.users.sort((a, b) => a.name < b.name ? -1 : 1)
          members.total.users.sort((a, b) => a.name < b.name ? -1 : 1)
        }

        this.members = members
      }

      // if (!this.globalChat && this.members.users.length) {
      //   setTimeout(() => {
      //     const elem = document.querySelector('.chat .chat-area')

      //     const currentpetList = document.querySelectorAll('.chat .chat-area .user-pet')
      //     currentpetList.forEach(el => {
      //       if (!this.members.users.some(u => el.dataset.id === u.id)) {
      //         elem.removeChild(el)
      //       }
      //     })

      //     this.members.users.forEach(user => {
      //       const currentpet = document.querySelector(`[data-id="${user.id}"]`)
      //       if (!currentpet && user.pet) {
      //         const img = document.createElement('img')
      //         img.src = `/static_files/items/pet-${user.pet}.svg`
      //         img.dataset.id = user.id
      //         img.className = 'user-pet'
      //         img.title = user.name
      //         if (elem) elem.appendChild(img)
      //       }
      //     })
      //     setTimeout(() => {
      //       this.petAnimated()
      //     }, 300)
      //   }, 1000)
      // }
    },
    getOnline(room = 'global') {
      clearInterval(this.onlineInterval)

      this.onlineInterval = setInterval(() => {
        this.$socket.emit('an:timeout', room, (members) => {
          this.members = members
        })
      }, 5 * 1000)
    },
    sendInvite() {
      const list = document.querySelectorAll('.friends input[type="checkbox"]')
      if (list) {
        const arr = []
        list.forEach((el) => {
          if (el.checked) {
            arr.push(el.getAttribute('id'))
          }
        })
        if (arr.length) {
          arr.forEach((friendId) => {
            const obj = {
              date: Date.now(),
              type: 'invite_room',
              to: friendId,
              from: {
                id: this.user.id,
                name: this.user.name,
                photo: this.user.photo,
                group: this.user.group
              },
              message: `Заходи ко мне в комнату, пообщаемся!`,
              payload: {
                _id: this.room.id,
                owner: this.room.owner,
                title: this.room.title
              }
            }
            this.$socket.emit('an:notification', obj)
          })
          this.showShare = false
          this.$store.commit('setError', { status: 'ok', msg: 'Приглашения отправлены' })
          setTimeout(() => this.$store.commit('clearError'), 2000)
        } else {
          this.$store.commit('setError', { status: 'info', msg: 'Выберите хотя бы одного друга' })
          setTimeout(() => this.$store.commit('clearError'), 2000)
        }
      }
    },
    async getFriendList() {
      const { data } = await this.$axios.get(`/api/user/friends`)
      if (!data.error) {
        this.userFriends = data
      }
    },
    uploadTrigger() {
      this.$refs.upload.click()
    },
    uploadFile(event, typeImg) {
      // if (!this.user) {
      //   this.$store.commit('setError', 'Для создания комнаты необходимо войти на сайт')
      //   setTimeout(() => this.$store.commit('clearError'), 2000)
      //   this.login()
      // }

      const file = event.target.files[0]

      if (file) {
        const fileType = file.type
        const imageExt = file.name.slice(file.name.lastIndexOf('.'))
        const imageSize = file.size / 1024

        if (
          (imageExt === '.gif' && imageSize < 1000) ||
          (imageExt === '.jpeg' && imageSize < 5000) ||
          (imageExt === '.jpg' && imageSize < 5000) ||
          (imageExt === '.png' && imageSize < 5000)
        ) {
          const vm = Object.assign(this)

          const reader = new FileReader()
          reader.readAsDataURL(file)

          const poster = document.querySelector('.create-room .room .poster')
          const child = poster.firstElementChild
          if (child) poster.removeChild(child)

          reader.onloadend = function() {
            const image = new Image()
            image.src = reader.result

            image.onload = function() {
              let finalFile

              if (imageExt === '.gif') {
                const div = document.querySelector('.create-room .room .poster')
                div.appendChild(image)

                finalFile = reader.result
              } else {
                const maxWidth = 300
                const maxHeight = 110

                let imageWidth = image.width
                let imageHeight = image.height

                if ((imageWidth > imageHeight) && (imageWidth > maxWidth)) {
                  imageHeight *= maxWidth / imageWidth
                  imageWidth = maxWidth
                } else if (imageHeight > maxHeight) {
                  imageWidth *= maxHeight / imageHeight
                  imageHeight = maxHeight
                }

                const canvas = document.createElement('canvas')
                canvas.width = imageWidth
                canvas.height = imageHeight

                const ctx = canvas.getContext('2d')
                ctx.drawImage(this, 0, 0, imageWidth, imageHeight)

                const div = document.querySelector('.create-room .room .poster')
                div.appendChild(canvas)

                finalFile = canvas.toDataURL(fileType)
              }

              if (!finalFile) return

              // The resized file ready for upload
              const fileName = `${Date.now()}${imageExt}`

              const arr = finalFile.split(',')
              const mime = arr[0].match(/:(.*?);/)[1]
              const bstr = atob(arr[1])
              let n = bstr.length
              const u8arr = new Uint8Array(n)

              while (n--) u8arr[n] = bstr.charCodeAt(n)

              const imageFile = new File([u8arr], fileName, { type: mime })

              const bodyFormData = new FormData()
              bodyFormData.append('image', imageFile)

              vm.createRoomPoster = bodyFormData
            }
          }
        } else {
          this.$store.commit(
            'setError',
            'Файл не соответствует условиям: формат .gif, .jpg, .jpeg или .png размером до 5Mb'
          )
          setTimeout(() => this.$store.commit('clearError'), 3000)
        }
      } else {
        this.$store.commit('setError', 'Ошибка загрузки')
        setTimeout(() => this.$store.commit('clearError'), 2000)
      }
    },
    showMembersToggle(type) {
      if (type === 'total' && this.showMembers.total) {
        this.showMembers.total = false
        return
      }
      if (type === 'inroom' && this.showMembers.inroom) {
        this.showMembers.inroom = false
        return
      }
      if (type === 'total') {
        this.showMembers.inroom = false
        this.showMembers.total = true
      } else {
        this.showMembers.total = false
        this.showMembers.inroom = true
      }
    },
    goToCinema(url) {
      this.$router.push(`/cinema/${url}`)
    },
    async approveFriend(pushId, friendly) {
      // console.log('approveFriend', pushId, friendly)
      const obj = {
        friendly_id: friendly.payload.friendly_id,
        user_id: friendly.from.id
      }
      await this.$axios.put('/api/user/friendly', obj)
      this.$store.commit('setError', { status: 'ok', msg: `Вы подружились с ${friendly.from.name}` })
      setTimeout(() => {
        this.$store.commit('clearError')
        location.reload()
      }, 2000)

      this.removePush(pushId)

      const nObj = {
        date: Date.now(),
        type: 'friendly_approve',
        to: friendly.from.id,
        from: {
          id: this.user.id,
          name: this.user.name,
          photo: this.user.photo,
          group: this.user.group
        },
        message: 'Пользователь принял ваше предложение дружбы',
        payload: null
      }
      this.$socket.emit('an:notification', nObj)
    },
    async switchProfileType(pushId) {
      await this.$axios.put('/api/user/closed', { closed: false })
      this.$store.commit('setError', { status: 'ok', msg: 'Профиль открыт' })
      setTimeout(() => this.$store.commit('clearError'), 1100)
      this.removePush(pushId)
    },
    async sendPM(pushId) {
      if (!this.PMtext) return
      const body = {
        to: this.sendPMUser,
        text: this.PMtext
      }
      const { data } = await this.$axios.post('/api/user/pm', body)
      // console.log('sendPM', data)
      if (data.error) {
        this.$store.commit('setError', { status: 'ok', msg: data.error.message })
      } else {
        this.$store.commit('setError', { status: 'ok', msg: 'Сообщение отправлено' })
      }

      setTimeout(() => this.$store.commit('clearError'), 1100)

      const obj = {
        date: Date.now(),
        type: 'pm',
        to: this.sendPMUser,
        from: {
          id: this.user.id,
          name: this.user.name,
          photo: this.user.photo,
          group: this.user.group
        },
        message: body.text,
        payload: null
      }
      this.$socket.emit('an:notification', obj)

      this.sendPMUser = null
      this.PMtext = ''

      this.removePush(pushId)
    },
    removePush(date) {
      const pushIndex = this.notifications.findIndex(el => el.date === date)
      this.notifications.splice(pushIndex, 1)
    },
    getPageTitle() {
      return document.title
    },
    deleteRoom(roomId) {
      this.$axios.delete(`/api/rooms?room_id=${roomId}&user_id=${this.user.id}`)
      this.$store.commit('setError', { status: 'ok', msg: 'Комната удалена' })
      setTimeout(() => this.$store.commit('clearError'), 2000)
      this.goToRoom({ _id: 'global', owner: null, title: 'Общая' })
    },
    goToRoom({ _id, owner, title }) {
      if (this.room.id === _id) {
        this.$store.commit('setError', { status: 'info', msg: 'Ты и так в этой комнате' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
        return
      }
      this.showChat = true
      this.showMembers = {
        total: false,
        inroom: false
      }
      // this.messages = []
      // this.roomsList = []
      this.showRoomsList = false
      this.showCreateRoom = false
      this.roomCreated = null
      this.room.id = _id
      this.room.owner = owner
      this.room.title = title
      this.routeEnter()
      const message = {
        text: `Вы перешли в комнату, "${title}"`,
        user: {
          id: null,
          name: 'ANIME777',
          photo: '/bot-avatar.png',
          group: -1
        }
      }
      this.messages.push(message)
    },
    async getRooms() {
      this.showRoomsList = !this.showRoomsList
      // if (this.roomsList.length) return
      if (!this.showRoomsList) return
      const { data } = await this.$axios.get(`/api/rooms`)
      if (data.length) {
        this.roomsList = data
      } else {
        this.$store.commit('setError', { status: 'info', msg: 'Комнаты не найдены' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      }
    },
    async createRoom() {
      if (!this.user) {
        this.$store.commit('setShowAuthForm', true)
        this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else if (!this.createRoomTitle.trim()) {
        this.$store.commit('setError', { status: 'info', msg: 'Необходимо указать название комнаты' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else if (this.createRoomTitle.trim().length < 3) {
        this.$store.commit('setError', { status: 'info', msg: 'Минимальная длина названия 3 символа' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else if (this.createRoomTitle.trim().length > 60) {
        this.$store.commit('setError', { status: 'info', msg: 'Максимальная длина названия 60 символов' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else {
        let posterUrl = null

        if (this.createRoomPoster) {
          posterUrl = await this.$axios({
            method: 'post',
            url: `/upload?type=rooms`,
            data: this.createRoomPoster,
            headers: { 'Content-Type': 'multipart/form-data' }
          })
        }

        const body = {
          owner: this.user.id,
          title: this.createRoomTitle.trim(),
          hidden: this.createRoomHidden,
          poster: posterUrl ? posterUrl.data.url : ''
        }
        const { data } = await this.$axios.post(`/api/rooms`, body)
        if (data.error) {
          this.$store.commit('setError', { status: 'warn', msg: data.error.message })
        } else {
          this.$store.commit('setError', { status: 'ok', msg: 'Комната успешно создана' })
          this.roomCreated = data
        }
        this.createRoomTitle = ''
        this.createRoomHidden = false
        setTimeout(() => this.$store.commit('clearError'), 2000)
      }
    },
    parseBB() {
      setTimeout(() => {
        const list = document.querySelectorAll('.messages li p')
        if (list) {
          Array.from(list).forEach((el) => {
            const match = el.textContent.match(/\[::.*::\]/)
            if (match) {
              const p = el
              let smilesCat = 'onion'
              if (p.textContent.includes('mafu_')) {
                smilesCat = 'mafu'
              } else if (p.textContent.includes('anityanochki_')) {
                smilesCat = 'anityanochki'
              }
              const str = p.textContent
                .replace(/\[::link="/g, `<a href="`)
                .replace(/"::\]/g, `">`)
                .replace(/\[::\/link::\]/g, '</a>')
                .replace(/\[::/g, `<img src="/static_files/onion/`)
                .replace(/::\]/g, `.gif" class="chat-emoji ${smilesCat}" />`)
              p.innerHTML = str
            }
          })
        }
        this.$nextTick(() => this.scrollChatMessages())
        const mpList = document.querySelectorAll('.message-push p')
        if (mpList) {
          Array.from(mpList).forEach((el) => {
            const match = el.textContent.match(/\[::.*::\]/)
            if (match) {
              const p = el
              const str = p.textContent
                .replace(/\[::/g, '<img src="/static_files/onion/')
                .replace(/::\]/g, '.gif" class="chat-emoji" />')
              p.innerHTML = str
            }
          })
        }
      }, 500)
    },
    showChatToggle() {
      this.showChatRead = false
      this.showChat = !this.showChat
      if (this.messagesUnread) {
        clearInterval(this.titleInterval)
        document.title = this.pageTitle
        this.messagesUnread = 0
      }
      this.$nextTick(() => this.parseBB())
    },
    appendEmoji(e) {
      // console.log(e)
      if (this.smilesCat === 'onion') {
        this.message += `[::${e}::] `
        if (this.isDesktop && this.$refs.chatInputMsg) {
          this.$refs.chatInputMsg.focus()
        }
      } else {
        this.message = `[::${e}::]`
        this.sendMessage()
      }
    },
    login() {
      if (this.globalChat) this.showChat = false
      this.$store.commit('setShowAuthForm', true)
      
      const playerResize = document.querySelector('.header.resize')
      if (playerResize) {
        playerResize.classList.remove('resize')
      }
    },
    async spamMember(msg) {
      await this.$axios.post(`/api/chat/spam`, msg)
      this.spamMembersList.push(msg.user.id)
      this.$store.commit('setError', { status: 'ok', msg: 'Жалоба отправлена' })
      setTimeout(() => this.$store.commit('clearError'), 1000)
    },
    async banMember(msg) {
      if (msg.user.group === 0) {
        this.$store.commit('setError', { status: 'warn', msg: 'Недостаточно прав' })
        setTimeout(() => this.$store.commit('clearError'), 1000)
        return
      }
      const body = {
        room_id: this.room.id,
        user_id: msg.user.id,
        msg: msg.text
      }
      await this.$axios.post(`/api/chat/ban`, body)
      this.banMembersList.push(msg.user.id)
      this.$store.commit('setError', { status: 'ok', msg: 'Пользователь заблокирован' })
      setTimeout(() => this.$store.commit('clearError'), 1000)
      this.$socket.emit('an:user:ban', msg)
    },
    async unbanMember(msg) {
      const body = {
        room_id: this.room.id,
        user_id: msg.user.id,
        msg: msg.text
      }
      await this.$axios.post(`/api/chat/unban`, body)
      const list = this.banMembersList.filter(el => el !== msg.user.id)
      this.banMembersList = list
      this.$store.commit('setError', { status: 'ok', msg: 'Пользователь разблокирован' })
      setTimeout(() => this.$store.commit('clearError'), 1000)
      this.$socket.emit('an:user:unban', msg)
    },
    sendMessage() {
      if (!this.user) {
        this.$store.commit('setError', { status: 'warn', msg: 'Необходимо войти на сайт' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else if (!this.user.id) {
        location.reload()
      } else if (!this.message.trim()) {
        this.$store.commit('setError', { status: 'warn', msg: 'Сообщение не может быть пустым' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      } else if (this.gets.msgtimeout) {
        this.$store.commit('setError', 'Нужно перевести дыхание')
        setTimeout(() => this.$store.commit('clearError'), 500)
      } else {
        this.gets.msgtimeout = true
        // console.log('this.user', this.user)
        const message = {
          text: this.message.trim(),
          user: {
            id: this.user.id,
            name: this.user.name || 'No name',
            photo: this.user.photo || '/no-avatar.svg',
            group: this.user.group,
            artifact: this.user.artifact,
            nickname_color: this.user.nickname_color,
            gender: this.user.gender,
            aura_color: this.user.aura_color,
            aura_item: this.user.aura_item
          }
        }
        if (this.pm) {
          const userInChat = this.members.users.filter(el => el.user.id === this.pm.id)
          if (!userInChat.length) {
            const obj = {
              date: Date.now(),
              type: 'pm',
              to: this.pm.id,
              from: {
                id: this.user.id,
                name: this.user.name,
                photo: this.user.photo,
                group: this.user.group
              },
              message: this.message,
              payload: null
            }
            this.$socket.emit('an:notification', obj)

            const messageBot = {
              text: 'Пользователь оффлайн. Ваше сообщение отправлено письмом.',
              user: {
                id: null,
                name: 'ANIME777',
                photo: '/bot-avatar.png',
                group: -1
              }
            }
            this.messages.push(messageBot)
            this.message = ''
            this.showSmiles = false
            // this.pm = null

            delete this.gets.msgtimeout
            return
          }
          message.pm = this.pm
        }
        const obj = {
          room: this.room.id,
          message
        }
        this.$socket.emit('an:message:new', obj)
        obj.message.date = new Date().setHours(new Date().getUTCHours() + 3)
        this.messages.push(obj.message)
        this.message = ''
        this.showSmiles = false
        this.parseBB()
        setTimeout(() => delete this.gets.msgtimeout, 500)
      }
    },
    scrollChatMessages() {
      if (document.querySelector('.messages')) {
        document.querySelector('.messages').scrollTop = document.querySelector('.messages').scrollHeight
      }
    },
    reply(name) {
      this.message = `${name}, `
      if (this.$refs.chatInputMsg) this.$refs.chatInputMsg.focus()
    },
    whisper(pmUser) {
      // console.log('pmUser', pmUser)
      if (this.user) {
        if (pmUser.id === this.user.id) return
        this.showMembers = {
          total: false,
          inroom: false
        }
        this.pm = pmUser
        if (!this.showChat) this.showChat = true
        this.$nextTick(() => {
          if (this.$refs.chatInputMsg) this.$refs.chatInputMsg.focus()
        })
      } else {
        this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      }
    },
    whisperCancel() {
      this.pm = null
      this.$store.commit('setWhisper', null)
    }
  }
}
</script>

<style src="~/assets/chat.styl" lang="stylus" />
